module.exports = __webpack_public_path__ + "img/Share.343d3f3a.svg";